import { ENVIRONMENTS } from "@/constants";
import { IApp } from "@/types";
import * as yup from "yup";

export const connectGoogleAccountSchema = yup.object().shape({
  userId: yup.string().min(2).max(1024).required(),
  type: yup.string().oneOf([IApp.IFeedTypes.GoogleSearchConsole, IApp.IFeedTypes.GoogleAnalytics]),
  env: yup.string().oneOf(ENVIRONMENTS).required(),
  code: yup.string().min(2).max(1024).required(),
  name: yup.string().min(2).max(1024).required(),
  redirectUrl: yup.string().min(2).max(1024).required()
});

export const connectBirdEyeSourceSchema = yup.object().shape({
  userId: yup.string().min(2).max(1024).required(),
  type: yup.string().oneOf([IApp.IFeedTypes.BirdEye]),
  env: yup.string().oneOf(ENVIRONMENTS).required(),
  name: yup.string().min(2).max(1024).required(),
  businessId: yup.string().min(2).max(32).required(),
  apiKey: yup.string().min(2).max(100).required(),
  redirectUrl: yup.string().min(2).max(1024).required()
});
